export default function responsiveValues (width) {
    let object
    //Mobiles
    if (width < 720) {
        object = {
            //INITIAL SETS
            objPosX: 0.4,
            objPosY: -10,
            objPosZ: -8,

            objRotX: Math.PI/2,
            objRotY: -Math.PI*1.1,
            objRotZ: -Math.PI/1,

            //Entry Animation
            entryObjPosY: 0,

            //Components Part
            ComponentsRotY: -Math.PI,
            ComponentsPosX: 0,
            ComponentPosZ: -9,
            CompoentsCameraPosY: 0,

            CameraPosY: -11,
        }
    }
    //Tablets
    else if (width >= 720 && width < 1024) {
        object = {
            objPosX: 0.4,
            objPosY: -10,
            objPosZ: -1,

            objRotX: Math.PI/2,
            objRotY: -Math.PI/5,
            objRotZ: -Math.PI/1,

            entryObjPosY: 0,

            ComponentsRotY: -Math.PI,
            ComponentsPosX: 0,
            ComponentPosZ: -10,
            CompoentsCameraPosY: 0,

            CameraPosY: -10,
        }
    }
    // Desktops
    else if (width >= 1024){
        object = {
            objPosX: 0,
            objPosY: -10,
            objPosZ: -1,

            objRotX: Math.PI/2,
            objRotY: Math.PI/2.01,
            objRotZ: -Math.PI/1,

            entryObjPosY: -0.5,

            ComponentsRotY:-Math.PI/2.02,
            ComponentsPosX: 0,
            ComponentPosZ: -4,

            CompoentsCameraPosY: 0,

            CameraPosY: -6.5,
        }
    }

    return object
}